/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Import_TitleInputs */

const en_dropbox_import_title = /** @type {(inputs: Dropbox_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from Dropbox`)
};

const es_dropbox_import_title = /** @type {(inputs: Dropbox_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar desde Dropbox`)
};

/**
* | output |
* | --- |
* | "Import from Dropbox" |
*
* @param {Dropbox_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_import_title = /** @type {((inputs?: Dropbox_Import_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Import_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_import_title(inputs)
	return en_dropbox_import_title(inputs)
});